import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  // null = still checking, false = not authenticated, object = authenticated admin
  const [admin, setAdmin] = useState(null);

  const check = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setAdmin(data);
    } catch {
      setAdmin(false);
    }
  }, []);

  useEffect(() => {
    check();
  }, [check]);

  const login = useCallback(
    async (email, password) => {
      await api.post("/auth/login", { email, password });
      await check();
    },
    [check]
  );

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } finally {
      setAdmin(false);
    }
  }, []);

  return (
    <AuthContext.Provider value={{ admin, login, logout, check }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
